import React, {useState} from 'react';
import {
    Popover,
    Flex,
    Text,
    AIStarIcon,
    PopoverPlacement,
    Button,
    Separator,
    RadioButton,
    Title
} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import texts from '../../texts';
import {getTopDialogZindex} from '../../../../_shared/GWTBridge/invoke/priModalDlg';
import {isRTL} from '../../../../Localization';
import {sendMonitor} from '../../../../utils/monitoring';
import {createDataTestId} from '../../../../utils/dataTestId';

interface Props {
    options: {
        label: string;
        value: string;
    }[];
    anchor: HTMLElement;
    confirmSuggestion: (string) => void;
    rejectSuggestion: () => void;
}

export const ConfirmationDialog = ({
    options,
    anchor,
    confirmSuggestion,
    rejectSuggestion
}: Props) => {
    const [open, setOpen] = useState(true);
    const [selected, setSelected] = useState<string>(options[0].value);

    const onSelect = (entityId: string) => {
        const selected = options.find(option => option.value === entityId);
        setSelected(selected.value);
    };

    const onConfirm = async () => {
        sendMonitor('PersonalizationMoreDetailsChooseSave');
        setOpen(false);
        await confirmSuggestion(selected);
    };

    const onReject = async () => {
        sendMonitor('PersonalizationMoreDetailsChooseCancel');
        setOpen(false);
        await rejectSuggestion();
    };

    const DialogHeader = (
        <Flex justifyContent="flex-start" {...createDataTestId('popover-edit-dialog-title', true)}>
            <div className={styles.icon}>
                <AIStarIcon />
            </div>
            <Title skin="h5" textColor="primary-700" text={texts.recommendation_title} />
        </Flex>
    );

    const content = (
        <>
            <Text skin="paragraph-2" componentClasses={styles.content}>
                {texts.recommendation_content}
            </Text>
            {selected && (
                <RadioButton
                    options={options}
                    selected={selected}
                    autoFocus
                    onChange={value => onSelect(value)}
                    border={false}
                    componentClasses={styles.options}
                />
            )}
        </>
    );

    const footer = (
        <Flex>
            <Button onClick={onReject} skin="text" size="medium">
                {texts.postpone_label}
            </Button>
            <Button onClick={onConfirm} size="medium" componentClasses={styles.footerBtn}>
                {texts.ok_label}
            </Button>
        </Flex>
    );

    return (
        <Popover
            {...createDataTestId('popover-confirmation-dialog-container', true)}
            show={open}
            title={DialogHeader}
            popoverComponentClass={styles.confirmationPopover}
            content={
                <div {...createDataTestId('popover-edit-dialog-text', false)}>
                    {content}
                    <Separator align="vertical" componentClasses={styles.separator} />
                    {footer}
                </div>
            }
            anchor={anchor}
            zIndex={getTopDialogZindex()}
            placement={isRTL() ? PopoverPlacement.leftStart : PopoverPlacement.rightStart}
            rtl
        />
    );
};
